import Vue from "vue";
import Vuex from "vuex";
import navigation from "./modules/navigation";
import wishlist from "./modules/wishlist";
import overview from "./modules/overview";
import filters from "./modules/filters";
import globals from "./modules/globals";
import cart from "./modules/cart";
import token from "./modules/token";
import user from "./modules/user";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    navigation,
    wishlist,
    overview,
    filters,
    globals,
    cart,
    token,
    user
  }
});
